import { render, staticRenderFns } from "./EditPasswordModal.vue?vue&type=template&id=b9e56224&scoped=true&"
import script from "./EditPasswordModal.vue?vue&type=script&lang=js&"
export * from "./EditPasswordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e56224",
  null
  
)

export default component.exports